export enum DATA_QA {
  ROOT = 'navigation-sidebar',
  ITEM = 'navigation-sidebar__item',
  MENU = 'navigation-sidebar__menu',
  LISTS = 'navigation-sidebar__item_lists',
  CAMPAIGNS = 'navigation-sidebar__item_campaigns',
  AVATAR = 'navigation-sidebar__avatar',
  NAME = 'navigation-sidebar__name',
  VERSION = 'navigation-sidebar__version',
  LOGOUT = 'navigation-sidebar__logout',
  FEEDBACK = 'navigation-sidebar__feedback',
  HELP = 'navigation-sidebar__help',

  // internal DT avatar iamge
  AVATAR_IMAGE = 'dt-avatar-image',
}
